import React from 'react';
import { useParams } from 'react-router-dom';
import { StyleSheet, View } from './components/base_components';
import StandardScreen from './components/standard_screen';

import BreadcrumbPath from './components/breadcrumb_path';
import UploadList from './components/upload_list';
import UploadProgresss from './components/upload_progress';

import UserStore from './stores/user_store';
import VolumeStore from './stores/volume_store';

import MediaIngest from './lib/media_ingest';

const styles = StyleSheet.create({
  volumeUploadScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
});

export default function VolumeUploadScreen(props) {
  const params = useParams();
  const org = UserStore.useOrg();
  const volume_id = parseInt(params.volume_id ?? '0', 10) || 0;
  const volume = VolumeStore.useVolume(org?.org_id, volume_id);
  const path = '/' + (params['*'] ?? '');
  const [list, setList] = React.useState<any[]>([]);
  const [show_progress, setShowProgress] = React.useState(false);

  React.useEffect(() => {
    VolumeStore.fetch(org?.org_id);
  }, [org?.org_id]);

  function _onUpload() {
    if (list?.length > 0) {
      MediaIngest.ingest({ volume_id, list }, () => {});
      setShowProgress(true);
    }
  }
  return (
    <View style={styles.volumeUploadScreen}>
      <StandardScreen>
        <BreadcrumbPath
          volumeName={volume?.volume_name}
          prefix={`/volume/${volume_id}/`}
          path={path}
          extra='Upload'
        />
        {show_progress ? (
          <UploadProgresss volumeId={volume_id} path={path} />
        ) : (
          <UploadList
            path={path}
            uploadList={list}
            onChange={setList}
            onUpload={_onUpload}
          />
        )}
      </StandardScreen>
    </View>
  );
}
